(function () {
  function currentRelativeUrl() {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
  }

  function safeRelativeUrl(value) {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
      return currentRelativeUrl();
    }

    return value;
  }

  window.theoricCustomerAuth = {
    requestSignIn(options = {}) {
      const modernAccountsEnabled = document.body?.dataset.modernCustomerAccounts === 'true';

      if (!modernAccountsEnabled) {
        if (window.theoricLoginPopup?.open) {
          window.theoricLoginPopup.open();
        } else {
          window.location.assign('/account/login');
        }
        return;
      }

      const returnTo = safeRelativeUrl(options.returnTo);
      const loginUrl = new URL('/customer_authentication/login', window.location.origin);
      loginUrl.searchParams.set('return_to', returnTo);
      window.location.assign(`${loginUrl.pathname}${loginUrl.search}`);
    }
  };
})();
